import axios from "axios";

const ApiEndpoint = "https://api.aircellar.lx-cloud.com/products";

export interface ProductDetails {
    name: string;
    year: string;
    location: string;
    starRating: number;
    numberOfRatings: number;
    matchPercentage: number;
    imageURL: string;
}

const productDetailCache: { [sku: string]: ProductDetails} = {};

export async function getProductDetailFromSku(sku: string): Promise<ProductDetails> {
    if (productDetailCache[sku] != null)
        return productDetailCache[sku];

    const getProductListResult = await axios.get(`${ApiEndpoint}/${sku}`)
        .catch(() => null);

    const productDetail = getProductListResult?.data as ProductDetails;

    if (productDetail)
        productDetailCache[sku] = productDetail;

    return productDetail ?? {
        name: "Unknown",
        year: "Unknown",
        location: "Unknown",
        starRating: 0,
        numberOfRatings: 0,
        matchPercentage: 0,
        imageURL: null,
    };
}